import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OrganizationalUnit } from 'components/types';

import { queries } from 'RestAPIs/rapini';

import { ControlledAutoComplete } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { FieldKey } from '../input-field-grants';
import dayjs from 'dayjs';
import { WorkPlaceResponse } from 'generated/index';
import ControlledFavoriteAutocomplete from 'components/shared/ControlledFields/ControlledFavoriteAutocomplete';

type Props = {
  enable?: boolean;
  control: Control<any>;
  organizationalUnit?: OrganizationalUnit;
  organizationalUnits?: OrganizationalUnit[];
  hasFieldGrant: (key: FieldKey) => boolean;
  handleWorkPlaceSelect: (
    project: WorkPlaceResponse | undefined | null
  ) => void;
};

const WhereSection = ({
  enable,
  control,
  organizationalUnit,
  organizationalUnits,
  hasFieldGrant,
  handleWorkPlaceSelect
}: Props) => {
  if (!enable) return null;

  return (
    <MultiStepForm.Section
      title="Waar"
      preview={organizationalUnit?.name}
      isEditable={hasFieldGrant('WHERE_IS_EDITABLE')}
      validateFields={[
        'organizationalUnit',
        ...(hasFieldGrant('WORKPLACE_ENTITY_ID') ? ['workPlaceEntityId'] : [])
      ]}
    >
      <OrganizationalUnitSelect
        control={control}
        organizationalUnits={organizationalUnits}
      />
      {hasFieldGrant('WORKPLACE_SELECT') && (
        <WorkplaceSelect
          control={control}
          organizationalUnitId={organizationalUnit?.id}
          handleSelect={handleWorkPlaceSelect}
        />
      )}
    </MultiStepForm.Section>
  );
};

const OrganizationalUnitSelect = ({
  control,
  organizationalUnits
}: {
  control: Control<any>;
  organizationalUnits: any;
}) => {
  const { t } = useTranslation();

  return (
    <ControlledAutoComplete
      name="organizationalUnit"
      control={control}
      label={t('planUnits')}
      variant="outlined"
      options={organizationalUnits ?? []}
      disableSorting
      fullWidth
      idProperty={'id'}
    />
  );
};

const WorkplaceSelect = ({
  control,
  organizationalUnitId,
  handleSelect
}: {
  control: Control<any>;
  organizationalUnitId: any;
  handleSelect?: (project: WorkPlaceResponse | undefined) => void;
}) => {
  const { t } = useTranslation();
  const { data: workPlaces } = queries.useGetWorkPlaces(
    dayjs().format('YYYY-MM-DD'),
    undefined,
    organizationalUnitId
  );

  return (
    <ControlledFavoriteAutocomplete
      type={'WORKPLACE'}
      name="workPlace"
      control={control}
      label={t('workPlace')}
      variant="outlined"
      options={workPlaces ?? []}
      disableSorting
      disableFavoriteFilter
      fullWidth
      onChange={handleSelect}
      idProperty={'entityId'}
    />
  );
};

export default WhereSection;
